import React from 'react';
import Card from '@mui/material/Card';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

export default function AccountingTopTabs({ value, onChange }) {
  return (
    <Card
      sx={{
        borderRadius: '18px',
        overflow: 'hidden',
        boxShadow: 'none',
        border: '1px solid rgba(0,0,0,0.08)',
      }}
    >
      <Tabs
        value={value}
        onChange={(_, v) => onChange(v)}
        variant="scrollable"
        scrollButtons="auto"
        sx={{
          px: 1,
          '& .MuiTab-root': {
            textTransform: 'none',
            fontWeight: 900,
            minHeight: 52,
          },
        }}
      >
        <Tab label="Genel Görünüm" />
        <Tab label="Gelirler" />
        <Tab label="Giderler" />
        <Tab label="Maaşlar" />
      </Tabs>
    </Card>
  );
}
